/**
 * 数据请求的唯一入口
 */

import projectDoc from "./projectDoc"
import roundDoc from "./roundDoc"
import athlete from "./athlete"
import team from "./team"
import raceDoc from './raceDoc'
import groupDoc from "./groupDoc"
import customer from "./customer"
import baseRound from "./baseRound"
import coach from "./coach"
import leader from "./leader"
import teamAthlete from "./teamAthlete"
import teamCoach from "./teamCoach"
import teamLeader from "./teamLeader"

export default {
    projectDoc,
    roundDoc,
    athlete,
    team,
    raceDoc,
    groupDoc,
    customer,
    baseRound,
    coach,
    leader,
    teamAthlete,
    teamCoach,
    teamLeader
}